export default __webpack_public_path__ + "static/media/a026-example1-en.a6a2a67f.png";